import { getApiBaseUrl, getFireBaseUrl } from './../helpers/Api'

export const PLATFORM = 'KHC-Gold'
export const constantValues = {
	otp_timer: 10,
	googleKey: 'AIzaSyCT9fmfRVY18bmUWTgr1kDoJcjr_LFre7w',
}

const baseURL = getApiBaseUrl()
const fireBaseURL = getFireBaseUrl()

export const endPoints = {
	userSession: `${baseURL}v2/sessions`,
	sendOTP: `${baseURL}v3/customers/sendOtp`,
	resendOTP: `${baseURL}v2/customers/sendOtp`,
	authenticateUser: `${baseURL}v2/customers/authenticate/mobile`,
	userDetails: `${baseURL}v2/customers/me`,
	validate: `${baseURL}v2/sessions/validate`,
	contestants: `${baseURL}juno-utility/v2/iim/contestants?active=true`,
	votes: `${baseURL}juno-utility/v2/iim/votes`,
	voterCheck: `${baseURL}v2/utility/lk-contest/leads`,
	leads: `${baseURL}v2/utility/lk-contest/leads`,
	timeline: `${baseURL}v2/utility/lk-contest/platforms/${PLATFORM}/timelines/active`,
	offersJSON: `${fireBaseURL}/khc-gold-config`,
	whatsApp: `${baseURL}v2/customers/whatsAppOpting?optingValue=true`,
	//khc api
	activeQuestion: `${baseURL}v2/utility/lk-contest/questions?platformName={platformName}&timelineId={timelineId}`,
	checkuserSubmission: `${baseURL}v2/utility/lk-contest/submissions/isExist`,
	submitQuizAnswers: `${baseURL}v2/utility/lk-contest/submissions`,
	getWinners: `${baseURL}v2/utility/lk-contest/results?platformName={platformName}`,
	scratchCardApi: `${baseURL}v2/utility/lk-contest/results/lead`,
	winnerTimelineApi: `${baseURL}v2/utility/lk-contest/timelines/{timelineId}`,
}

export const GA = {
	eventName: 'LSPKHC',
	phoneVerificationPage: 'LSPKHC Input Number',
	namePage: 'LSPKHC Name Screen',
	emailPage: 'LSPKHC Email Screen',
	dobPage: 'LSPKHC DOB Screen',
	genderPage: 'LSPKHC Gender Screen',
	addressPage: 'LSPKHC Address Screen',
	votingPage: 'LSPKHC Question Screen',
	voterDetailPage: "LSPKHC Voter's details",
	verifyOtpPage: 'LSPKHC Verify OTP',
	voteNowPage: 'LSPKHC Landing Screen',
	thankYouPage: 'LSPKHC Thank you',
	alreadySubmitted: 'LSPKHC Already Submitted',
	votingClosedPage: 'LSPKHC Timeline closed',
	//khc
	scratchCardPage: 'LSPKHC Scratch Card',
	winnersPage: 'LSPKHC All Winners',
	kbcScratchCard: 'LSPKHC Scratch KBC Card',
	lkScratchCard: 'LSPKHC Scratch LK Card',
	blntScratchCard: 'LSPKHC Scratch BLNT Card',
}
